export default __webpack_public_path__ + "static/media/zermont.3736b582.jpg";